import React from 'react';

/** School branding row: logo image when the school has one, gradient initial otherwise. */
const SchoolHeader = ({ name, logo }) => (
	<div className="flex items-center gap-[10px]">
		{logo ? (
			<img src={logo} alt="" className="h-[40px] w-[40px] rounded-[10px] object-cover" />
		) : (
			<div className="flex h-[40px] w-[40px] items-center justify-center rounded-[10px] bg-gradient-to-br from-[#676AF6] to-[#36CEE5] text-[18px] font-bold text-white">
				{(name || 'P').charAt(0).toUpperCase()}
			</div>
		)}
		<p className="text-[16px] font-bold text-[#16181d]">{name || 'Perfect Day'}</p>
	</div>
);

export default SchoolHeader;
